
import React, {useState} from "react";
import settingsClasses from "../PlatformSetting/Settings.module.css";
import {YuJaRadioBox} from "../../components/standardization/YuJaRadiobox";
import {
    ATMPT_DROPDOWN,
    ATTEMPT_SYNC_TO_GRADE_BOOK_DESCRIPTION,
    AUDIENCE_RESTRICTION,
    AUDIENCE_RESTRICTION_COURSE, AUDIENCE_RESTRICTION_DESCRIPTION_ATTENDANCE, AUDIENCE_RESTRICTION_DESCRIPTION_POLL,
    AUDIENCE_RESTRICTION_EVERYONE,
    AUDIENCE_RESTRICTION_LOGGED_IN,
    AUDIENCE_RESTRICTION_NAME, AUDIENCE_RESTRICTION_TITLE,
    COURSE_PLACEHOLDER, GRADE_BOOK_TEXT,
    GRADE_SCHEMA, LMS_GRADEBOOK_SYNC, PARTICIPANT_RESTRICTION_DISABLING_REASON, POLL_ATTEMPT_SETTINGS_TEXT,
    POLL_TYPE,
    RADIAL_LABEL,
    RECORD_ATTEMPT,
    RECORD_ATTEMPT_TITLE, SYNC_ATTEMPT, UNLIMITED_MAX_ATTEMPTS_SETTING_TEXT, USER_SETTINGS, YUJA_DROPDOWN_SIZE
} from "../../utils/constants";
import {YuJaDropdown} from "../../components/standardization/YuJaDropdown";
import {YuJaTooltip} from "../../components/standardization/YuJaTooltip";
import {YuJaToggle} from "../../components/standardization/YuJaToggle";
import {YuJaTextBox} from "../../components/standardization/YuJaTextBox";
import classes from "./ActivityEditor.module.css";


export default function ActivityEditorConfigurationSectionB({draftActivity, setDraftActivity, userSettings, courseList, hasReleased}) {
    const columnLayoutStyle = {width: "100%", display: "flex", flexDirection: "column"};
    const recordAttemptOptions = [RECORD_ATTEMPT.ALL, RECORD_ATTEMPT.RECENT];
    const attemptSettingsArr = [
        LMS_GRADEBOOK_SYNC.FIRST,
        LMS_GRADEBOOK_SYNC.RECENT,
        LMS_GRADEBOOK_SYNC.HIGHEST
    ];

    const [maxAttempts, setMaxAttempts] = useState(!!draftActivity.attempts ? `${draftActivity.attempts}` : "-1");


    const onClickAudienceRestriction = (val) => {
        let copy = JSON.parse(JSON.stringify(draftActivity));
        copy.audienceRestriction = val;
        setDraftActivity(copy);
    }

    const handleRecordAttemptOptionClick = (value) => {
        const copy = JSON.parse(JSON.stringify(draftActivity));
        if (value === RECORD_ATTEMPT.RECENT.value) {
            copy.recordAttempt = SYNC_ATTEMPT.RECENT.value;
            copy.lmsAttempt = LMS_GRADEBOOK_SYNC.RECENT.value;
        } else if (value === RECORD_ATTEMPT.ALL.value) {
            copy.recordAttempt = RECORD_ATTEMPT.ALL.value;
            copy.lmsAttempt = userSettings[USER_SETTINGS.POLL_LMS_SYNC];
        }
        setDraftActivity(copy);
    };

    const handleLMSAttemptSettingChange = (item) => {
        const copy = JSON.parse(JSON.stringify(draftActivity));
        copy.lmsAttempt = item.value;
        setDraftActivity(copy);
    };

    const onChangeMaximumAttempts = (e) => {
        const copy = JSON.parse(JSON.stringify(draftActivity));
        if (e.target.checked) {
            copy.maxAttempts = -1;
        } else {
            copy.maxAttempts = 1;
        }
        setDraftActivity(copy);
    }


    const disableParticipantRestriction =
        (draftActivity.pollType === POLL_TYPE.MERGED_POLL
            && draftActivity.gradeSchema ===GRADE_SCHEMA.GRADED.key
            && !!draftActivity.syncLms)
        || (draftActivity.pollType === POLL_TYPE.ATTENDANCE && !!draftActivity.syncLms);


    return (
        <div className={classes.settingsGridLayout}>
            {!!hasReleased &&
                <div
                    style={{
                        position: "absolute", top: 0, left: 0, right: 0, bottom: 0,
                        background: "#E6E6E6", opacity: 0.5,
                        cursor: "not-allowed", zIndex: 1
                    }}
                />
            }



            {/* participant restrictions  */}
            <div style={{...columnLayoutStyle, gridColumn: "1/-1"}}>
                <div className={settingsClasses.settingLabel}>{AUDIENCE_RESTRICTION_TITLE}</div>
                <div className={settingsClasses.settingDescription}>
                    {draftActivity.pollType === POLL_TYPE.ATTENDANCE
                        ? AUDIENCE_RESTRICTION_DESCRIPTION_ATTENDANCE
                        : AUDIENCE_RESTRICTION_DESCRIPTION_POLL
                    }
                </div>

                <div style={{display: "flex", flexDirection: "column", gap: 8, marginTop: 8, position: "relative"}}>
                    <YuJaRadioBox
                        size={18}
                        labelStyle={{fontSize: 14, lineHeight: 1.6, fontWeight: "400"}}
                        label={AUDIENCE_RESTRICTION_EVERYONE}
                        checked={draftActivity.audienceRestriction === AUDIENCE_RESTRICTION.UNRESTRICTED}
                        onClick={() => onClickAudienceRestriction(AUDIENCE_RESTRICTION.UNRESTRICTED)}
                    />
                    <YuJaRadioBox
                        size={18}
                        labelStyle={{fontSize: 14, lineHeight: 1.6, fontWeight: "400"}}
                        label={AUDIENCE_RESTRICTION_NAME}
                        checked={draftActivity.audienceRestriction === AUDIENCE_RESTRICTION.NAME_REQUIRED}
                        onClick={() => onClickAudienceRestriction(AUDIENCE_RESTRICTION.NAME_REQUIRED)}
                    />
                    <YuJaRadioBox
                        size={18}
                        labelStyle={{fontSize: 14, lineHeight: 1.6, fontWeight: "400"}}
                        label={AUDIENCE_RESTRICTION_LOGGED_IN}
                        checked={draftActivity.audienceRestriction === AUDIENCE_RESTRICTION.LOGGED_IN}
                        onClick={() => onClickAudienceRestriction(AUDIENCE_RESTRICTION.LOGGED_IN)}
                    />

                    <YuJaRadioBox
                        size={18}
                        labelStyle={{fontSize: 14, lineHeight: 1.6, fontWeight: "400"}}
                        label={AUDIENCE_RESTRICTION_COURSE}
                        checked={draftActivity.audienceRestriction === AUDIENCE_RESTRICTION.REGISTERED}
                        onClick={() => onClickAudienceRestriction(AUDIENCE_RESTRICTION.REGISTERED)}

                    />
                    {draftActivity.audienceRestriction === AUDIENCE_RESTRICTION.REGISTERED &&

                        <YuJaDropdown
                            placeholder={COURSE_PLACEHOLDER}
                            searchAble={true}
                            containerStyle={{minWidth: 200, maxWidth: 320, marginTop: 5}}
                            size={"small"}
                            data={courseList}
                            value={draftActivity.courseId}
                            onChange={option => {
                                const copy = JSON.parse(JSON.stringify(draftActivity));
                                copy.courseId = option.value;
                                setDraftActivity(copy);
                            }}
                        />
                    }

                    {!!disableParticipantRestriction && !hasReleased &&
                        <YuJaTooltip
                            tooltipStyle={{maxWidth: 350}}
                            text={PARTICIPANT_RESTRICTION_DISABLING_REASON}
                        >
                            <div
                                style={{
                                    position: "absolute", top: 0, left: 0, right: 0, bottom: 0,
                                    background: "#E6E6E6", opacity: 0.5,
                                    cursor: "not-allowed", zIndex: 1
                                }}
                            />
                        </YuJaTooltip>
                    }
                </div>
            </div>

            {/*Attempt sync to Grade Book */}
            {draftActivity.pollType !== POLL_TYPE.ATTENDANCE &&
                <>
                    <div style={columnLayoutStyle}>
                        <div className={settingsClasses.settingLabel}>{GRADE_BOOK_TEXT}</div>
                        <div className={settingsClasses.settingDescription}>{ATTEMPT_SYNC_TO_GRADE_BOOK_DESCRIPTION}</div>
                    </div>

                    <YuJaDropdown
                        ariaLabel={ATMPT_DROPDOWN + userSettings[USER_SETTINGS.POLL_LMS_SYNC]}
                        containerStyle={{width: 250, flexShrink: 0}}
                        data={attemptSettingsArr}
                        value={draftActivity.lmsAttempt}
                        onChange={handleLMSAttemptSettingChange}
                        size={YUJA_DROPDOWN_SIZE.SMALL}
                        disabled={draftActivity.recordAttempt === SYNC_ATTEMPT.RECENT.value}
                    />
                </>
            }


            {/*Poll max Attempts*/}
            {draftActivity.pollType !== POLL_TYPE.ATTENDANCE &&
                <>
                    <div style={columnLayoutStyle}>
                        <div className={settingsClasses.settingLabel}>{POLL_ATTEMPT_SETTINGS_TEXT}</div>
                        <div className={settingsClasses.settingDescription}>{UNLIMITED_MAX_ATTEMPTS_SETTING_TEXT}</div>
                    </div>

                    <YuJaToggle
                        containerStyle={{flexShrink: 0}}
                        name={"userSettingsUnlimitedAttemptsToggle"}
                        toggled={!draftActivity.maxAttempts || parseInt(draftActivity.maxAttempts) < 0}
                        onClick={onChangeMaximumAttempts}
                    />

                    {!!draftActivity.maxAttempts && parseInt(draftActivity.maxAttempts) > 0 &&
                        <>
                            <span className={settingsClasses.settingDescription} style={{width: "100%"}}>
                                {"Set maximum attempts allowed."}
                            </span>

                            <YuJaTextBox
                                containerStyle={{width: 50, height: 35}}
                                inputAlign={"center"}
                                value={draftActivity.maxAttempts}
                                onChange={(e) => setMaxAttempts(e.target.value)}
                                placeholder={"1"}
                                type={"number"}
                                onBlur={() => {
                                    const copy = JSON.parse(JSON.stringify(draftActivity));
                                    if (!maxAttempts) {
                                        copy.maxAttempts = -1;
                                    } else if (parseInt(maxAttempts) > 0) {
                                        copy.maxAttempts = parseInt(maxAttempts);
                                        setMaxAttempts(`${parseInt(maxAttempts)}`);
                                    }else {
                                        copy.maxAttempts = -1;
                                    }
                                    setDraftActivity(copy);
                                }}
                            />
                        </>
                    }
                </>
            }

            {/*  Record Attempts  */}
            {draftActivity.pollType !== POLL_TYPE.ATTENDANCE &&
                <div style={{...columnLayoutStyle, gridColumn: "1/-1"}}>
                    <span className={settingsClasses.settingLabel}> {RECORD_ATTEMPT_TITLE} </span>
                    <div style={{display: "flex", flexDirection: "column", gap: 8, marginTop: 8}}>
                        {recordAttemptOptions.map((optionData, index) => {
                            const {value, label} = optionData;
                            return (
                                <YuJaRadioBox
                                    key={index}
                                    aria-label={label + RADIAL_LABEL + (value === draftActivity.recordAttempt ? "selected" : "unselected")}
                                    label={label}
                                    style={{width: "fit-content", fontSize: 14, lineHeight: 1.6, fontWeight: "400"}}
                                    checked={draftActivity.recordAttempt === value}
                                    onClick={() => handleRecordAttemptOptionClick(value)}
                                />
                            );
                        })}
                    </div>
                </div>
            }

        </div>
    );
}